import axios from 'axios';

import api from './api/axiosInstance';
export const login = async (subscriptionKey, email, password) => {
    try {
        const response = await api.get(`/Login?key=${subscriptionKey}&Email=${email}&Password=${password}`);

        if (response.data.result) {
            return { success: true, user: response.data.userDm }; // Return user details
        } else {
            return { success: false, message: response.data.msg };
        }
    } catch (error) {
        return { success: false, message: error.response.data.msg };
    }
};

// Function to handle user logout
export const logout = (id) => {

    // Remove both email and token from local storage
    localStorage.removeItem('user');
    localStorage.removeItem('token');

    // Redirect to login page or home page
    window.location.href = '/login/' + id; // Change to your preferred route
};
